// 拜访记录
// const VisitRecord = () => import(/* webpackChunkName: "VisitRecord" */ '@/pages/statistics/visit.vue');
// 签到记录
const SignInRecord = () => import(/* webpackChunkName: "SignInRecord" */ '@/pages/statistics/signin.vue');
// 打卡记录
const TimingRecord = () => import(/* webpackChunkName: "TimingRecord" */ '@/pages/statistics/timingRecord.vue');
// 医生电话联系统计
const DocTelConnection = () => import(/* webpackChunkName: "DocTelConnection" */ '@/pages/statistics/doctel-connection.vue');
// 数据看板
// const DataBoard = () => import('@/pages/statistics/dataBoard.vue');
// 销售业绩统计
const SalesPerformance = () => import(/* webpackChunkName: "SalesPerformance" */ '@/pages/statistics/salesPerformance/salesPerformance.vue');
// 二级部门业务统计
const Department2 = () => import(/* webpackChunkName: "Department2" */ '@/pages/statistics/salesPerformance/department2.vue');
// 三级部门业务统计
const Department3 = () => import(/* webpackChunkName: "Department3" */ '@/pages/statistics/salesPerformance/department3.vue');
// 销售人员业务统计
const Salesman = () => import(/* webpackChunkName: "Salesman" */ '@/pages/statistics/salesPerformance/salesman.vue');
// 产品线业务统计
const Productline = () => import(/* webpackChunkName: "Productline" */ '@/pages/statistics/productLine/productline.vue');
// 部门分产品线业务统计
const ProductlineOfDepartment = () => import(/* webpackChunkName: "ProductlineOfDepartment" */ '@/pages/statistics/productLine/productlineOfDepartment.vue');
// 二级部门分产品线业务统计
const ProductlineOfDepartment2 = () => import(/* webpackChunkName: "ProductlineOfDepartment2" */ '@/pages/statistics/productLine/productlineOfDepartment2.vue');
// 三级部门分产品线业务统计
const ProductlineOfDepartment3 = () => import(/* webpackChunkName: "ProductlineOfDepartment3" */ '@/pages/statistics/productLine/productlineOfDepartment3.vue');
// 客户分产品线业务统计
const ProductlineOfCustomer = () => import(/* webpackChunkName: "ProductlineOfCustomer" */ '@/pages/statistics/productLine/productlineOfCustomer.vue');
// 客户业务统计
const Customer = () => import(/* webpackChunkName: "Customer" */ '@/pages/statistics/customer/customer.vue');
// 客户营收Top10(保险)
const CustomerOfInsurance = () => import(/* webpackChunkName: "CustomerOfInsurance" */ '@/pages/statistics/customer/customerOfInsurance.vue');
// 客户营收Top10(银行)
const CustomerOfBank = () => import(/* webpackChunkName: "CustomerOfBank" */ '@/pages/statistics/customer/customerOfBank.vue');
// 客户营收Top10(运营商)
const CustomerOfOperator = () => import(/* webpackChunkName: "CustomerOfOperator" */ '@/pages/statistics/customer/customerOfOperator.vue');
// 客户营收Top10(健管公司)
const CustomerOfHealth = () => import(/* webpackChunkName: "CustomerOfHealth" */ '@/pages/statistics/customer/customerOfHealth.vue');
// 客户营收Top10(互联网公司)
const CustomerOfInternet = () => import(/* webpackChunkName: "CustomerOfInternet" */ '@/pages/statistics/customer/customerOfInternet.vue');
// 服务总量统计
const ServiceTotal = () => import(/* webpackChunkName: "serviceTotal" */ '@/pages/statistics/serviceData/serviceTotal.vue');
// 项目服务量统计
const ProjectServiceTotal = () => import(/* webpackChunkName: "projectServiceTotal" */ '@/pages/statistics/serviceData/projectServiceTotal.vue');
// 项目线下服务Top10
const ProjectOfflineTop10 = () => import(/* webpackChunkName: "projectOfflineTop10" */ '@/pages/statistics/serviceData/projectOfflineTop10.vue');
// 项目线上服务Top10
const ProjectOnlineTop10 = () => import(/* webpackChunkName: "projectOnlineTop10" */ '@/pages/statistics/serviceData/projectOnlineTop10.vue');
// 线下服务统计
const OfflineService = () => import(/* webpackChunkName: "offlineService" */ '@/pages/statistics/serviceData/offlineService.vue');
// 线上咨询统计
const OnlineConsultation = () => import(/* webpackChunkName: "onlineConsultation" */ '@/pages/statistics/serviceData/onlineConsultation.vue');
// 电话咨询统计
const TelephoneCounseling = () => import(/* webpackChunkName: "telephoneCounseling" */ '@/pages/statistics/serviceData/telephoneCounseling.vue');

const arr = [
  // 拜访记录
  // {
  //   path: '/statistics/visitRecord',
  //   name: 'visitRecord',
  //   component: VisitRecord,
  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: false,
  //   },
  // },
  // 签到记录
  // {
  //   path: '/statistics/signInRecord',
  //   name: 'signInRecord',
  //   component: SignInRecord,
  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: false,
  //   },
  // },
  // 打卡记录
  // {
  //   path: '/statistics/timingRecord',
  //   name: 'timingRecord',
  //   component: TimingRecord,
  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: false,
  //   },
  // },
  // 医生电话联系统计
  {
    path: '/statistics/docTelConnection',
    name: 'docTelConnection',
    component: DocTelConnection,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 数据看板
  // {
  //   path: '/statistics/dataBoard',
  //   name: 'dataBoard',
  //   component: DataBoard,
  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: false,
  //   },
  // SalesmanPerformance

  // },
  // 销售业绩统计
  {
    path: '/statistics/salesPerformance',
    name: 'salesPerformance',
    component: SalesPerformance,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },

  // 二级部门业务统计
  {
    path: '/statistics/secondDepartmentPerformance',
    name: 'secondDepartmentPerformance',
    component: Department2,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 三级部门业务统计
  {
    path: '/statistics/thirdDepartmentPerformance',
    name: 'thirdDepartmentPerformance',
    component: Department3,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 销售人员业务统计
  {
    path: '/statistics/salesmanPerformance',
    name: 'salesmanPerformance',
    component: Salesman,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 产品线业务统计
  // {
  //   path: '/statistics/performanceByProductline',
  //   name: 'performanceByProductline',
  //   component: Productline,
  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: false,
  //   },
  // },
  // 部门分产品线业务统计
  // {
  //   path: '/statistics/productlineOfDepartment',
  //   name: 'productlineOfDepartment',
  //   component: ProductlineOfDepartment,
  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: false,
  //   },
  // },
  // 二级部门分产品线业务统计
  // {
  //   path: '/statistics/secDepPerformanceByProductline',
  //   name: 'secondDepartmentPerformanceByProductline',
  //   component: ProductlineOfDepartment2,
  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: false,
  //   },
  // },
  // 三级部门分产品线业务统计
  // {
  //   path: '/statistics/thirdDepPerformanceByProductline',
  //   name: 'thirdDepartmentPerformanceByProductline',
  //   component: ProductlineOfDepartment3,
  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: false,
  //   },
  // },
  // 客户分产品线业务统计
  // {
  //   path: '/statistics/cusPerformanceByProductline',
  //   name: 'customerPerformanceByProductline',
  //   component: ProductlineOfCustomer,
  //   // If the user needs to be authenticated to view this page
  //   meta: {
  //     auth: false,
  //   },
  // },
  // 客户业务统计
  {
    path: '/statistics/customerPerformance',
    name: 'customerPerformance',
    component: Customer,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 客户营收Top10(保险)
  {
    path: '/statistics/insureCusPerformance',
    name: 'insureCustomerPerformance',
    component: CustomerOfInsurance,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 客户营收Top10(银行)
  {
    path: '/statistics/bankCusPerformance',
    name: 'bankCustomerPerformance',
    component: CustomerOfBank,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 客户营收Top10(运营商)
  {
    path: '/statistics/operatorCusPerformance',
    name: 'operatorCustomerPerformance',
    component: CustomerOfOperator,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 客户营收Top10(健管公司)
  {
    path: '/statistics/healthCusPerformance',
    name: 'healthCustomerPerformance',
    component: CustomerOfHealth,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 客户营收Top10(互联网公司)
  {
    path: '/statistics/internetCusPerformance',
    name: 'internetCustomerPerformance',
    component: CustomerOfInternet,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 服务总量统计
  {
    path: '/statistics/serviceTotal',
    name: 'serviceTotal',
    component: ServiceTotal,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 项目服务量统计
  {
    path: '/statistics/projectServiceTotal',
    name: 'projectServiceTotal',
    component: ProjectServiceTotal,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 项目线下服务Top10
  {
    path: '/statistics/projectOfflineTop10',
    name: 'projectOfflineTop10',
    component: ProjectOfflineTop10,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 项目线上服务Top10
  {
    path: '/statistics/projectOnlineTop10',
    name: 'projectOnlineTop10',
    component: ProjectOnlineTop10,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 线下服务统计
  {
    path: '/statistics/offlineService',
    name: 'offlineService',
    component: OfflineService,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 线上咨询统计
  {
    path: '/statistics/onlineConsultation',
    name: 'onlineConsultation',
    component: OnlineConsultation,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
  // 电话咨询统计
  {
    path: '/statistics/telephoneCounseling',
    name: 'telephoneCounseling',
    component: TelephoneCounseling,
    // If the user needs to be authenticated to view this page
    meta: {
      auth: false,
    },
  },
];

export default arr;
